import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';

@Injectable()
export class AuthenticationService {

  constructor(private http: HttpClient, private global: Env) { }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  public isAuthenticated(): string {
    // get the token
    const token = this.getToken();
    // return a boolean reflecting
    // whether or not the token is expired
    // return tokenNotExpired(null, token);
    return token;
  }

  login(username: string, password: string): any {

    if(username !== '' && password !== ''){

      const url: string = this.global.oauth;
      const user: string =  this.global.ANGULAR_CLIENT_ID;
      const pass: string = this.global.ANGULAR_CLIENT_SECRET;
      const code_basic = btoa(user + ':' + pass);
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': 'Basic ' + code_basic,
          'Content-Type': 'application/x-www-form-urlencoded'
        }),
      };
      const parameters = 'username='+username+'&password='+password+'&grant_type=password';
      return this.http.post(url, parameters, httpOptions).map((res: any) => {
        res = res;
        if (res && res.access_token) {
          localStorage.setItem('token', res.access_token);
          localStorage.setItem('data', JSON.stringify(res));
        }else {
          localStorage.removeItem('token');
          localStorage.removeItem('data');
        }
      });
    }
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
    localStorage.removeItem('data');
  }


}




// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/authentication.service.ts